import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/contexts/ToastContext";
import { getApiErrorMessage } from "@/lib/api-error";
import { binderyApi } from "@/lib/api/bindery";
import { formFromThesisRequest } from "./thesis-form-from-request";
import { useThesisForm } from "./useThesisForm";

export function useEditableThesis(id: string | undefined) {
  const navigate = useNavigate();
  const toast = useToast();
  const formApi = useThesisForm();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!id) return;
    let active = true;
    binderyApi.thesis
      .mineById(id)
      .then((req) => {
        if (!active) return;
        if (req.status !== "SUBMITTED") {
          toast.error("This request can no longer be edited.");
          navigate(`/my/thesis/${id}`, { replace: true });
          return;
        }
        formApi.hydrate(formFromThesisRequest(req));
        setReady(true);
      })
      .catch((err) => {
        if (!active) return;
        toast.error(getApiErrorMessage(err, "Failed to load thesis request"));
        navigate("/my/thesis", { replace: true });
      });
    return () => {
      active = false;
    };
  }, [id, formApi.hydrate, navigate, toast]);

  return { ...formApi, ready };
}
